import apiV2 from "api-v2";
import type {
	EvaluationCriterion,
	CreateCriterionPayload,
	UpdateCriterionPayload,
	CopyCriteriaPayload,
	CriteriaSearchResult,
} from "../types/criteria.type";

const unwrap = <T>(responseData: any): T => {
	if (responseData && typeof responseData === "object" && "data" in responseData) {
		return responseData.data;
	}
	return responseData;
};

export const getCriteria = async (rfxId: number): Promise<EvaluationCriterion[]> => {
	const response = await apiV2.get(`/rfx/${rfxId}/criteria`);
	const data = unwrap<{ criteria: EvaluationCriterion[] }>(response.data);
	return data?.criteria ?? [];
};

export const createCriterion = async (
	rfxId: number,
	payload: CreateCriterionPayload
): Promise<EvaluationCriterion> => {
	const response = await apiV2.post(`/rfx/${rfxId}/criteria`, payload);
	return unwrap<EvaluationCriterion>(response.data);
};

export const updateCriterion = async (
	rfxId: number,
	criterionId: number,
	payload: UpdateCriterionPayload
): Promise<EvaluationCriterion> => {
	const response = await apiV2.put(`/rfx/${rfxId}/criteria/${criterionId}`, payload);
	return unwrap<EvaluationCriterion>(response.data);
};

export const deleteCriterion = async (
	rfxId: number,
	criterionId: number
): Promise<void> => {
	await apiV2.delete(`/rfx/${rfxId}/criteria/${criterionId}`);
};

export const copyCriteria = async (
	rfxId: number,
	payload: CopyCriteriaPayload
): Promise<EvaluationCriterion[]> => {
	const response = await apiV2.post(`/rfx/${rfxId}/criteria/copy`, payload);
	return unwrap<EvaluationCriterion[]>(response.data) ?? [];
};

export const searchCompanyCriteria = async (
	companyId: number,
	search: string
): Promise<CriteriaSearchResult[]> => {
	const response = await apiV2.get(`/company/${companyId}/criteria`, { params: { search } });
	return unwrap<CriteriaSearchResult[]>(response.data) ?? [];
};
